"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var BaseCollectionQuery_1 = require("./BaseCollectionQuery");
var BaseValueCollectionQuery = /** @class */ (function (_super) {
    __extends(BaseValueCollectionQuery, _super);
    function BaseValueCollectionQuery(queryOptions, translationHelper) {
        return _super.call(this, queryOptions, translationHelper) || this;
    }
    BaseValueCollectionQuery.prototype.getRawValueOrRootKey = function (executionOptions) {
        var rootKey = this.queryOptions.rootKey;
        if (rootKey) {
            var collectionItem = this.getCollectionItem(executionOptions);
            return collectionItem[rootKey];
        }
        return this.getRawValueFromSubCollection(executionOptions);
    };
    BaseValueCollectionQuery.prototype.getRawValueFromSubCollection = function (executionOptions) {
        var _this = this;
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        var _a = this.options, key = _a.key, collectionItemValueConditional = _a.collectionItemValueConditional;
        return this.processEntities(executionOptions, function (entity) {
            if (entity) {
                var collectionItem = _this.getCollectionItem(executionOptions);
                var _a = (collectionItem || {}).values, values = _a === void 0 ? [] : _a;
                var matchingValues = values.filter(function (value) {
                    return !collectionItemValueConditional ||
                        conditionalHelper.matchesWithOptions({
                            executionOptions: executionOptions,
                            instance: value,
                            conditional: collectionItemValueConditional,
                        });
                });
                if (matchingValues && matchingValues.length > 0) {
                    var item = _this.getItem(executionOptions, matchingValues);
                    if (item) {
                        if (key) {
                            return item[key];
                        }
                        return item;
                    }
                }
            }
        });
    };
    BaseValueCollectionQuery.prototype.getCollectionItem = function (executionOptions) {
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        var _a = this.options, code = _a.code, _b = _a.collectionItemConditional, collectionItemConditional = _b === void 0 ? { conditions: [] } : _b;
        if (code &&
            !collectionItemConditional.conditions.find(function (condition) { return condition.field === 'code'; })) {
            collectionItemConditional.conditions.push({
                field: 'code',
                operator: '=',
                value: code,
            });
        }
        var subCollection = this.getSubCollection(executionOptions);
        if (subCollection) {
            var collectionItem = subCollection.find(function (item) {
                return conditionalHelper.matchesWithOptions({
                    executionOptions: executionOptions,
                    instance: item,
                    conditional: collectionItemConditional,
                });
            });
            return collectionItem;
        }
        return undefined;
    };
    return BaseValueCollectionQuery;
}(BaseCollectionQuery_1.BaseCollectionQuery));
exports.BaseValueCollectionQuery = BaseValueCollectionQuery;
//# sourceMappingURL=BaseValueCollectionQuery.js.map